import { Skeleton } from '@mui/material';

import { Spacer } from 'theSource/components';
import { ThemedHeader } from 'components/ThemedHeader';

export const BenefitByBenefitLoader = () => {
  return (
    <div style={{ paddingTop: '5rem' }} data-testid="benefit-by-benefit-loader">
      <ThemedHeader>
        <Skeleton
          variant="rectangular"
          height={30}
          width={200}
          role="status"
          aria-label="Loading..."
        />
      </ThemedHeader>
      <Spacer height={4} />
      <Skeleton
        variant="rectangular"
        height={100}
        width={600}
        role="status"
        aria-label="Loading..."
      />
      <Spacer height={4} />
      <div className="card">
        <Skeleton
          variant="rectangular"
          height={350}
          width={800}
          role="status"
          aria-label="Loading..."
        />
      </div>
    </div>
  );
};
